import React from "react";
import ReactDOM from "react-dom/client";
import { analytics } from "@heycatch/sdk";
import "@/index.css";
import App from "@/App";

analytics.init({
  projectKey: "hck_pk_gjG1KtZrEiDQ7WPzwAeypC9kM_HJuFR3",
  install: { framework: "react", frameworkVersion: "19", agent: "other" },
});

const rootElement = document.getElementById("root");

// PWA: register the service worker (skipped during react-snap prerender)
if ("serviceWorker" in navigator && navigator.userAgent !== "ReactSnap") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// Support react-snap prerendering: hydrate if content already exists
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
